import * as React from 'react';

import Tooltip from '../Tooltip';

interface Props {
    className: string;
    onClick?: () => void;
    name: string;
    level: number | string;
    showSpellLevel: boolean;
    isCustomized: boolean;
    showIcons: boolean;
    isRitual: boolean;
    isConcentration: boolean;
    showExpandedType: boolean;
    expandedTypeText: string | null;
    isDarkMode?: boolean;
    concentrationIcon?: React.ReactNode;
    ritualIcon?: React.ReactNode;
}

export default class SpellName extends React.Component<Props> {
    static defaultProps = {
        className: '',
        isCustomized: false,
        showIcons: true,
        showSpellLevel: true,
        showExpandedType: false,
        expandedTypeText: null,
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    renderIcons = (): React.ReactNode => {
        const { isRitual, isConcentration, concentrationIcon, ritualIcon } = this.props;
        let renderedConcentrationIcon, renderedRitualIcon;
        if (isConcentration && concentrationIcon) {
            renderedConcentrationIcon = concentrationIcon;
        } else if (isConcentration) {
            renderedConcentrationIcon = (
                <i className="ddbc-spell-name__icon ddbc-spell-name__icon--concentration i-concentration" />
            );
        }
        if (isRitual && ritualIcon) {
            renderedRitualIcon = ritualIcon;
        } else if (isRitual) {
            renderedRitualIcon = <i className="ddbc-spell-name__icon ddbc-spell-name__icon--ritual i-ritual" />;
        }

        return (
            <React.Fragment>
                {renderedConcentrationIcon}
                {renderedRitualIcon}
            </React.Fragment>
        );
    };

    render() {
        const {
            name,
            showExpandedType,
            showSpellLevel,
            expandedTypeText,
            level,
            isCustomized,
            showIcons,
            className,
            isDarkMode,
        } = this.props;

        let classNames: Array<string> = [className, 'ddbc-spell-name'];

        if (isDarkMode) {
            classNames.push('ddbc-spell-name--dark-mode');
        }

        return (
            <span className={classNames.join(' ')} onClick={this.handleClick}>
                {showExpandedType && expandedTypeText && (
                    <Tooltip title={expandedTypeText} className="ddbc-spell-name__expanded" isDarkMode={isDarkMode}>
                        +
                    </Tooltip>
                )}
                {name}
                {isCustomized && (
                    <Tooltip
                        title="Spell is Customized"
                        className="ddbc-spell-name__customized"
                        isDarkMode={isDarkMode}
                    >
                        *
                    </Tooltip>
                )}
                {showIcons && this.renderIcons()}

                {showSpellLevel && (
                    <span className={`ddbc-spell-name__level ${isDarkMode ? 'ddbc-spell-name__level' : ''}`}>
                        ({level})
                    </span>
                )}
            </span>
        );
    }
}
